import {
  provideAppInitializer,
  type EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';

import { AUTH_CONFIG, type EbtAuthConfig } from './auth-config.token';
import { authBoot } from './auth.interceptor';

/**
 * Drop-in providers for an app's `appConfig.providers` array.
 *
 *   provideEbtAuth({
 *     audience: 'internal',
 *     loginPath: `${env.apiBaseUrl}/auth/login`,
 *     refreshPath: `${env.apiBaseUrl}/auth/refresh`,
 *     logoutPath: `${env.apiBaseUrl}/auth/logout`,
 *     mePath: `${env.apiBaseUrl}/auth/me`,
 *     loginRoute: '/login',
 *     postLoginRoute: '/',
 *   })
 *
 * The interceptor is registered separately via `withInterceptors` on
 * `provideHttpClient`, because that's where Angular's functional
 * interceptors plug in — see the app configs. Keeping them split makes
 * the registration order explicit (interceptor sees the auth boot
 * before the first user-initiated HTTP).
 */
export function provideEbtAuth(config: EbtAuthConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AUTH_CONFIG, useValue: config },
    provideAppInitializer(authBoot()),
  ]);
}
